<div class="welcome-page">
    <div class="base-info">
        <div class="content-container">
            <div class="content">
                <h2>{{ 'welcome.title' | translate }}</h2>
                <p>{{ 'welcome.step1' | translate }}</p>
                <p>{{ 'welcome.step2' | translate }}</p>
                <p>{{ 'welcome.step3' | translate }}</p>
            </div>
        </div>
    </div>
    <div class="register-info">
        <form (ngSubmit)="onSubmit()" #form="ngForm">
            <img src="../../../assets/freight-logo.svg" alt="freight-logo">
            <div class="form-group">
                <input class="form-input" name="email" type="email" id="welcome-email"
                    [(ngModel)]="email" placeholder="{{ 'welcome.email' | translate }}" #emailInput="ngModel"
                    required/>
                <label for="welcome-email" class="form_label">{{ 'welcome.email' | translate }}</label>
                <div *ngIf="form.submitted && emailInput.invalid"
                    class="alert alert-danger">
                    <span>{{ 'welcome.enterEmail' | translate }}</span>
                </div>
            </div>
            <div class="form-group">
                <input class="form-input" name="newPass" type="password" id="welcome-pass"
                    [(ngModel)]="password" placeholder="{{ 'welcome.createPassword' | translate }}" #passInput="ngModel"
                    required/>
                <label for="welcome-pass" class="form_label">{{ 'welcome.createPassword' | translate }}</label>
                <div *ngIf="form.submitted && passInput.invalid"
                    class="alert alert-danger">
                    <span>{{ 'welcome.enterPassword' | translate }}</span>
                </div>
            </div>
            <div class="actions">
                <button type="submit" class="primary-button" id="registerBtn">
                    {{ 'welcome.register' | translate }}
                </button>
                <div>
                    <span>{{ 'welcome.alreadyRegistered' | translate }}</span>
                    <a [routerLink]="['']">{{ 'welcome.signIn' | translate }}</a>
                </div>
            </div>
        </form>
        <div class="info">
            <p>{{ 'welcome.questions' | translate }} <a href="tel:+18448186243">844-818-6243</a></p>
        </div>
    </div>
</div>